"use client"

import { usePathname } from "next/navigation"

import A from "./A"

export default function Back() {
  const pathname = usePathname()

  if (pathname === "/") {
    return null
  }

  return <A href="/">Zurück</A>
}
